"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextFormatterDisplayWidget = exports.DefaultAllowedTags = exports.TextFormatterHeight = exports.TextFormatterMinWidth = void 0;
var tslib_1 = require("tslib");
var DOMPurify = require("dompurify");
var React = require("react");
var textile = require("textile-js");
var FocusIndicator_1 = require("../../utils/FocusIndicator");
exports.TextFormatterMinWidth = 340;
exports.TextFormatterHeight = 200;
exports.DefaultAllowedTags = Object.freeze([
    'a', 'abbr', 'b', 'blockquote', 'br', 'caption', 'cite', 'code', 'dd', 'del', 'div', 'dl', 'dt',
    'em', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'ins', 'li', 'nl', 'ol', 'p', 'pre', 'span',
    'strike', 'strong', 'sub', 'sup', 'table', 'tbody', 'td', 'th', 'thead', 'tr', 'u', 'ul',
]);
var TextFormatterDisplayTestIdSuffix = '-TextFormatterDisplayWidget';
/* Set up sanitize options for use with textile */
var defaultOptions = {
    ALLOWED_TAGS: tslib_1.__spreadArrays(exports.DefaultAllowedTags),
};
function convertMarkupToSanitizedHtml(markup, config) {
    var dirty = textile(markup);
    // open all links in new tab
    DOMPurify.addHook('afterSanitizeAttributes', function (node) {
        if (node.tagName === 'A' && node.hasAttribute('href')) {
            node.setAttribute('target', '_blank');
            node.setAttribute('rel', 'noopener');
        }
    });
    return { clean_FOR_FRONT_END_ONLY: DOMPurify.sanitize(dirty, tslib_1.__assign(tslib_1.__assign({}, defaultOptions), config)) };
}
exports.TextFormatterDisplayWidget = function (props) {
    var allowedTags = props.allowedTags, markup = props.markup, testId = props.testId, restProps = tslib_1.__rest(props, ["allowedTags", "markup", "testId"]);
    var clean_FOR_FRONT_END_ONLY = React.useMemo(function () { return convertMarkupToSanitizedHtml(markup, (allowedTags && { ALLOWED_TAGS: tslib_1.__spreadArrays(allowedTags) })); }, [markup, allowedTags]).clean_FOR_FRONT_END_ONLY;
    return React.createElement(FocusIndicator_1.__UNSTABLE__INTERNAL__FocusIndicator, null,
        React.createElement("div", tslib_1.__assign({ "data-tb-test-id": testId + TextFormatterDisplayTestIdSuffix }, restProps, { dangerouslySetInnerHTML: { __html: clean_FOR_FRONT_END_ONLY }, tabIndex: 0 })));
};
exports.TextFormatterDisplayWidget.displayName = 'TextFormatterDisplayWidget';
//# sourceMappingURL=TextFormatterDisplayWidget.js.map